import styled from 'styled-components';
import React, { FC, ReactNode } from 'react';
import { useLockBodyScroll } from '../hooks/use-lock-body-scroll';

interface OverlayStyleProp {
  $openMenu: boolean;
  $delay: string;
}

export interface OverlayProps {
  onClick: () => void;
  onTransitionEnd?: () => void;
  children: ReactNode;
}

const StyledOverlay = styled.div<OverlayStyleProp>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 250;
  background: rgba(0, 0, 0, 0.6);
  opacity: ${(props): string => `${props.$openMenu ? 1 : 0}`};
  transition: opacity 0.4s linear ${(props): string => `${props.$delay}`};
  backdrop-filter: blur(4px);
`;

export const Overlay: FC<OverlayProps & OverlayStyleProp> = ({
  $openMenu,
  $delay,
  onClick,
  onTransitionEnd,
  children,
}) => {
  useLockBodyScroll();

  return (
    <StyledOverlay
      $openMenu={$openMenu}
      $delay={$delay}
      onClick={(event) => {
        event.stopPropagation();
        onClick();
      }}
      onTransitionEnd={onTransitionEnd}
    >
      {children}
    </StyledOverlay>
  );
};
